<template>
  <div>
    <div class="card mb-2">
      <div class="card-body">
        <a :href="post.url" target="_blank" @click="click()" v-if="post.picture">
          <img :src="post.picture" width="100" class="float-right ml-3 rounded w-25">
        </a>

        <h5 class="card-title mb-1 d-none d-md-block">
          <a :href="post.url" target="_blank" @click="click()" v-html="post.title"></a>
        </h5>
        <h6 class="card-title mb-1 d-block d-md-none">
          <a :href="post.url" target="_blank" @click="click()" v-html="post.title"></a>
        </h6>

        <div class="card-text d-none d-md-block" v-html="truncate(post.excerpt, 120)"></div>
        <div class="card-text d-block d-md-none" v-html="truncate(post.excerpt, 50)"></div>

        <div class="d-flex">
          <router-link :to="'/sources/' + post.source.id" class="text-muted">
            {{ post.source.name }}
          </router-link>
          <span class="mx-2 text-primary">&bull;</span>
          <router-link :to="'/posts/' + post.slug" class="text-muted">
            <timeago :datetime="post.publishedAt"></timeago>
          </router-link>

          <favorite :post="post" class="ml-3" v-on:unfavorited="$emit('unfavorited', $event)"></favorite>

          <div class="ml-3" @click="share()" v-if="$isGoNative">
            <fa-icon :icon="['fal', 'share']"></fa-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-2" v-if="(index + 1) % 5 === 0">
      <div class="col-12 col-md-6">
        <ad :zone="108" class="px-1 s300x100"></ad>
      </div>
      <div class="col-12 col-md-6 mt-2 mt-lg-0" v-if="!$isMobile">
        <ad :zone="109" class="px-1 s300x100"></ad>
      </div>
    </div>
  </div>
</template>

<script>
  import Favorite from './favorite.vue';
  import Ad from '@/vues/helpers/ad.vue';

  export default {
    name: 'Post',
    components: { Favorite, Ad },
    props: {
      post: Object,
      index: Number
    },
    methods: {
      truncate (str, length) {
        return this.$options.filters.truncate(str, length);
      },

      async click () {
        await this.$http.get('posts/' + this.post.id + '/click');

        try {
          this.$ua.trackEvent('post', 'click');
        } catch (e) { /* Adblocker */ }

        try {
          this.$mixpanel.track('Post Click', {
            postId: this.post.id,
            source: this.post.source.name,
            url: this.post.url,
            title: this.post.title
          });
        } catch (e) { /* Adblocker */ }
      },

      share () {
        window.location.href = 'gonative://share/sharePage?url=' + encodeURI('https://www.jagdnews.de/posts/' + this.post.slug);
      }
    }
  };
</script>

<style scoped>
  img {
    max-width: 100px;
  }
</style>
